<template>
  <div class="container" style=" background-color: #EAEAEA;">
    <HeaderComponent :menu-id="1" :show-search="true"></HeaderComponent>

    <!-- 搜索结果 -->
    <div class="content-container"
      style="width: 1200px; margin: 0 auto 20px; padding: 20px 0; background-color: #fff; border-radius: 10px;"
      v-if="info && info.errorCode == 0">
      <!-- 盒子轮播图 -->
      <div v-if="imgArray.length > 0">
        <a :href="imgArray[active]" target="_blank">
          <img :src="imgArray[active]" style="width: 500px; height: 500px; object-fit: contain;" />
        </a>
      </div>
      <!-- 裸币拼图 -->
      <a style="display: block; margin: 0 auto; padding-top: 20px;" :href="preImage" target="_blank"><img
          v-if="info.limg" :src="preImage" class="luobi-image" /></a>
      <div class="content-wrapper">
        <div class="content-line">
          <div class="content-label">名称</div>
          <img class="content-image" v-if="rarelyInfo && rarelyInfo.kingRarelyName" :src="rarelyInfo.kingRarelyName" />
          <div class="content-value" v-else>{{ info.title }}</div>
        </div>
        <div class="content-line" v-if="info.banshi">
          <div class="content-label">版式</div>
          <img class="content-image" v-if="rarelyInfo && rarelyInfo.kingRarelyBanshi"
            :src="rarelyInfo.kingRarelyBanshi" />
          <div class="content-value" v-else>{{ info.banshi }}</div>
        </div>
        <div class="content-line" v-if="info.showyear == 1">
          <div class="content-label">年代</div>
          <div class="content-value">{{ info.nianfen }}</div>
        </div>
        <div class="content-line">
          <div class="content-label">分数</div>
          <div class="content-value">
            <span v-if="info.fenzhi != null && (info.fenzhi.includes('MS') || info.fenzhi.includes('AU') || info.fenzhi.includes('XF') || info.fenzhi.includes('VF'))">{{ info.fenzhi + (info.xiaci ? " " + info.xiaci : "") }}</span>
            <span v-else-if="info.xiaci && info.xiaci != '00'">{{ info.xiaci }}</span>
            <span v-else>{{ info.fenzhi != '无' ? info.fenzhi : '' }}</span>
          </div>
        </div>
        <div class="content-line" v-if="info.chicun && info.kezhong != 'null'">
          <div class="content-label">尺寸</div>
          <div class="content-value">{{ info.chicun }}</div>
        </div>
        <div class="content-line" v-if="info.kezhong && info.kezhong != 'null'">
          <div class="content-label">重量</div>
          <div class="content-value">{{ info.kezhong }}g</div>
        </div>
        <div class="content-line" v-if="info.caizhi">
          <div class="content-label">材质</div>
          <div class="content-value">{{ info.caizhi }}</div>
        </div>
        <!-- <div class="content-line" v-if="info.guzhi > 0 && info.jiazhi"> -->
        <div class="content-line" v-if="info.jiazhi">
          <div class="content-label">估值</div>
          <div class="content-value">{{ info.jiazhi }}</div>
        </div>
        <div class="content-line" v-if="info.memo">
          <div class="content-label">备注</div>
          <div class="content-value">{{ info.memo }}</div>
        </div>
        <div class="content-line" style="width: 100%;" v-if="info.pingshu">
          <div>
            <span style="color: #c8b686; font-family: 'SourceHanSansSC-Bold';">水石评述：</span>
            {{ info.pingshu }}
          </div>
        </div>
        <div class="content-memo">
          <div class="content-memo-title">温馨提示：</div>
          <div class="content-memo-text" v-if="info.recall == 1">钱币召回赔付中，请勿交易。</div>
          <div class="content-memo-text" v-else>如购买价格已超出估值，可申请复评提升估值，避免风险和损失。</div>
        </div>
      </div>
      <div class="content-wrapper" v-if="info.ximg">
        <div
          style="font-size: 32upx; line-height: 3em; width: 540px; margin: 0 auto 20px; font-family: 'SourceHanSansSC-Bold';">
          X光图
        </div>
        <a :href="info.ximg" target="_blank"><img
            style="width: 300px; height: 300px; display: block; margin: 0px auto 20px auto;" :src="info.ximg" /></a>
      </div>
    </div>

    <!---无结果--->
    <div style="width: 1200px; margin: 0 auto 20px; padding: 20px 0; background-color: #fff; border-radius: 10px;"
      v-else>
      <div style="color: #ff0000; font-size: 18px; text-align: center; margin-top: 20px;">没有找到相关信息，请核对后重试</div>
      <img style="margin: 0 auto; width: 750px; height: 734px;" src="@/assets/image/wuneirong.png" alt="">
    </div>


    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

import { API, doGet } from "@/api/api.js"

export default {
  data() {
    return {
      show: true,
      active: 0,
      imgArray: [],
      info: {},
      preImage: "",
      rarelyInfo: {},
    }
  },
  methods: {
    getData: async function () {
      if (this.$store.state.code) {
        this.info = await doGet(API.SEARCH, { code: this.$store.state.code });
        console.log("this.info={}", this.info);
        if (this.info && this.info.errorCode == 0) {
          this.rarelyInfo = await doGet(API.RARELY, { code: this.$store.state.code });
          this.info.title = this.info.title.replace("#背", "背").replace("#", " ").replace("%", "").replace("&", " ").replace("$", "").replace("@", " ");
          this.info.banshi = this.info.banshi ? this.info.banshi.replace("#", " ").replace("%", "").replace("&", " ").replace("$", "").replace("@", " ") : "";
          //中括号新规则
          this.info.title = this.info.title.replace(/\[\s*(.*?)\s*\]/g, '$1');
          this.info.banshi = this.info.banshi.replace(/\[\s*(.*?)\s*\]/g, '$1');
          this.imgArray = [];
          if (this.info.img1) {
            this.imgArray.push(this.info.img1);
          }
          if (this.info.img2) {
            this.imgArray.push(this.info.img2);
          }
          this.preImage = await doGet(API.PREVIEW, { num: this.$store.state.code });
        }
        else {
          this.show = false;
        }
      }
    }
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
    this.getData();
    // let numIndex = 0;
    // if (location.href.lastIndexOf('?i=') > 0) {
    //   numIndex = location.href.lastIndexOf('?i=') + 3;
    // }
    // else {
    //   numIndex = location.href.lastIndexOf('/') + 1;
    // }
    // this.num = location.href.slice(numIndex);
    // this.getData();
    // setInterval(() => {
    //   if (this.imgArray.length > 0) {
    //     this.active = (this.active + 1) % this.imgArray.length;
    //   }
    // }, 2000);
  },
  watch: {
    '$store.state.code'() {
      this.getData();
    },
  }
}
</script>
<style lang="less" scoped>
.home-wrap {
  width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 60px;
}

// 搜索框
.search-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;

  .search-label {
    background: #947c44;
    color: #fff;
    padding: 10px 28px;
    border-radius: 24px 0 0 24px;
  }

  .search-input {
    height: 40px;
    padding: 0 12px;
    border: none;
    outline: none;
  }

  .search-icon {
    background: #fff;
    padding: 0 16px 0 4px;
    border-radius: 0 24px 24px 0;
    height: 40px;
    display: flex;
    align-items: center;
  }
}

// 顶部两个卡片
.card-group {
  display: flex;
  gap: 24px;
  margin-bottom: 40px;

  .info-card {
    flex: 1;
    background: #a88e54;
    border-radius: 12px;
    text-align: center;
    padding: 48px 20px;
    color: #fff;

    h2 {
      font-size: 32px;
      font-weight: normal;
      margin: 0 0 24px;
    }

    p {
      font-size: 18px;
      line-height: 1.6;
      margin-bottom: 32px;
    }

    .card-btn {
      border: none;
      background: #fff;
      color: #333;
      padding: 8px 24px;
      border-radius: 4px;
      font-size: 16px;
      cursor: pointer;
    }
  }
}

// 下半部分
.bottom-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;

  .left-part {
    text-align: center;

    .red-tag {
      border: 2px solid #b82626;
      color: #b82626;
      display: inline-block;
      padding: 6px 20px;
      border-radius: 6px;
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .coin-img-box img {
      width: 220px;
    }
  }

  .divider {
    width: 1px;
    height: 160px;
    background: #cccccc;
  }

  .right-part {
    h3 {
      font-size: 24px;
      color: #222;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 3px;
        background: #947c44;
      }
    }

    ul {
      list-style: none;
      padding: 0;
      text-align: center;
      font-size: 18px;
      line-height: 1.8;
      margin: 16px 0 24px;
    }

    .red-btn {
      border: 2px solid #b82626;
      color: #b82626;
      background: transparent;
      padding: 8px 24px;
      border-radius: 6px;
      font-size: 16px;
      cursor: pointer;
    }
  }
}

.luobi-image {
  width: 600px;
  height: 300px;
  margin: 0 auto;
  padding: 0 20px;
}

.content-wrapper {
  width: 600px;
  margin: 20px auto;
}

.content-line {
  margin: 0 auto;
  width: 540px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px dashed #ccc;
  font-size: 16px;
}

.content-label {
  color: #D6A755;
}

.content-image {
  height: 30px;
}

.content-memo {
  width: 540px;
  margin: 20px auto;
}

.content-memo-title {
  color: #b82626;
  font-size: 15px;
}

.content-memo-text {
  font-size: 15px;
  margin-top: 5px;
}
</style>